import { applyMiddleware, createStore, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native

import { reducer as toastr } from 'react-redux-toastr';
import login from './login';
import forgotPassword from './forgotPassword';
import signup from './signup';
import user from './user';
import nurseshift from './nurseshift';
import step4 from './step4';
import onboardingContactInfo from './onboarding/contactInfo';
import onboardingPreferences from './onboarding/preferences';
import progressBar from './progressBar';
import calendar from './calendar';
import shiftdetail from './shiftdetail';
import account from './account';
import supervisorAccount from './supervisor/account';
import supervisorshiftlist from './supervisor/supervisorshiftlist';
import supervisordashboard from './supervisor/supervisordashboard';
import supervisorShift from './supervisor/shift';
import supervisorshiftdetails from './supervisor/supervisorshiftdetails';
import adminDashboard from './admin/adminDashboard';
import requirement from './admin/requirement';
import globalUser from './admin/user';
import adminOrganization from './admin/organization';
import userIndex from './admin/userIndex';
import orgdetails from './admin/orgdetails';
import shiftIndex from './admin/shiftIndex';
import nurseAccount from './nurse/account';
import requests from './admin/requests';
import checkout from './checkout';
import supervisorTimesheets from './supervisor/timesheets';
import supervisortimesheetdetail from './supervisor/supervisortimesheetdetail';
import adminTimesheets from './admin/timesheet';
import adminTimesheetDetail from './admin/timesheetdetail';
import editShift from './supervisor/editShift';
import dnr from './admin/dnr';
import userTestFeature from './userTestFeature';
import bookmarks from './nurse/bookmark';
import loyalty from './loyalty';
import errorReporting from './errorReporting';
import assignShift from './nurse/assignShift';
import nps from './nps';
import resources from './resources';
import features from './features';
import supervisorSchedule from './supervisor/supervisorSchedule';
import permissions from './admin/permissions';
import { clearLocalStorage } from '../utils/user';

const persistConfig = {
	blacklist: ['step3', 'errorReporting', 'signup', 'login', 'adminDashboard', 'supervisorAccount'],
	key: 'root',
	storage // Disable persist for following reducers
};

const reducers = combineReducers({
	account,
	adminDashboard,
	adminOrganization,
	adminTimesheetDetail,
	adminTimesheets,
	assignShift,
	bookmarks,
	calendar,
	checkout,
	dnr,
	editShift,
	errorReporting,
	features,
	forgotPassword,
	globalUser,
	login,
	loyalty,
	nps,
	nurseAccount,
	nurseshift,
	onboardingContactInfo,
	onboardingPreferences,
	orgdetails,
	permissions,
	progressBar,
	requests,
	requirement,
	resources,
	shiftdetail,
	shiftIndex,
	signup,
	step4,
	supervisorAccount,
	supervisordashboard,
	supervisorSchedule,
	supervisorShift,
	supervisorshiftdetails,
	supervisorshiftlist,
	supervisortimesheetdetail,
	supervisorTimesheets,
	toastr,
	user,
	userIndex,
	userTestFeature
});

const rootReducer = (state, action) => {
	if (action.type === 'RESET_LOGIN') {
		// Reset state on logout
		state = undefined;
		clearLocalStorage();
	}

	return reducers(state, action);
};

export const configureStore = (debug = true) => {
	// redux middleware
	const middleware = [thunk];
	const persistedReducer = persistReducer(persistConfig, rootReducer);

	if (debug) {
		const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
		return createStore(persistedReducer, composeEnhancers(applyMiddleware(...middleware)));
	}

	return createStore(persistedReducer, applyMiddleware(...middleware));
};
